export const RENAME_DIFF_ARGS = ['-M', '--find-renames'] as const;
